<template>
    <DCard
        padding
    >
        <Form
            :countries="countries"
            :effectiveness="effectiveness"
            :errors="errors"
            :is-finance-system-netsuite="isFinanceSystemNetsuite"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/TaxRules/Form'

export default {
    name: 'TaxRuleCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        countries: {
            type: Array,
            default: () => { return [] }
        },
        tenantLanguages: {
            type: Array,
            default: () => []
        },
        effectiveness: {
            type: Array,
            default: () => []
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.tax-rules.store'))
        }
    }
}
</script>
